module.exports = __webpack_public_path__ + "@/assets/img/folder-cloud.e38aa7d2.svg";